import { Accordion } from './index';
import { styled } from '@mui/material/styles';

export const PopperAccordion = styled(Accordion)`
  box-shadow: none;
  &:not(:last-child) {
    border-bottom: 0;
  }
  ,
  &:before {
    display: none;
  }
`;
